var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaLargaRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7944 5.5025C17.8544 5.4425 17.9044 5.3625 17.9344 5.2925C17.9444 5.2625 17.9544 5.2425 17.9644 5.21249C17.9844 5.15249 17.9944 5.0925 18.0044 5.0325C18.0044 5.0025 18.0044 4.9825 18.0044 4.9525C18.0044 4.8725 17.9844 4.79249 17.9544 4.71249C17.9544 4.71249 17.9544 4.7125 17.9544 4.7025C17.9144 4.6225 17.8644 4.5425 17.8044 4.4825C17.8044 4.4825 17.8044 4.46249 17.7844 4.46249L13.5244 0.212495C13.2344 -0.0775049 12.7544 -0.0775049 12.4644 0.212495C12.1744 0.502495 12.1744 0.982495 12.4644 1.2725L15.4444 4.2425H0.754395C0.344395 4.2425 0.00439453 4.5825 0.00439453 4.9925C0.00439453 5.4025 0.344395 5.7425 0.754395 5.7425H15.4444L12.4644 8.71249C12.1744 9.00249 12.1744 9.4825 12.4644 9.7725C12.6144 9.9225 12.8044 9.9925 12.9944 9.9925C13.1844 9.9925 13.3744 9.9225 13.5244 9.7725L17.7844 5.5225L17.7944 5.5025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaLargaRight);
export default __webpack_public_path__ + "static/media/flecha_larga_right.3eb37b49.svg";
export { ForwardRef as ReactComponent };